let locales = {};

import keyFob from "../../keyFobsTab/lan/es";
import crew from "../../crewTab/lan/es";
import equipment from "../../equipmentTab/lan/es";
import fuelCard from "../../fuelCardTab/lan/es";
import temperature from "../../temperatureTab/lan/es";
import driverStatus from "../../driverStatusTab/lan/es";
import locations from "../../locationsTab/lan/es";
import behavior from "../../behaviorTab/lan/es";
import inputs from "../../inputsTab/lan/es";
import cameraManagement from "../../cameraManagementTab/lan/es";
import vehicleStatus from "../../vehicleStatusTab/lan/es";

locales = { ...keyFob, ...crew, ...equipment, ...fuelCard, ...temperature, ...driverStatus, ...locations, ...inputs, ...cameraManagement, ...behavior, ...vehicleStatus };

export default locales;
